import rank from "@/utils/bip_game_ranks20210204.json";
import configs from "@/config/config.js";
import require from "./require";
const state = () => ({
  GameList: [],
  recentPlayList: [],
  actionlist: {},
  // 这个是流量的固定的游戏
  GameFlow: {},
  // 评分数据
  evaluationState: {
    popup: false
  },
  //
  openAppLoginStatus: false
});

function shuffle(a) {
  var b = [];
  while (a.length) {
    var index = ~~(Math.random() * a.length);
    b.push(a[index]);
    a.splice(index, 1);
  }
  return b;
}

function unique(arr) {
  var result = [];
  var obj = {};
  for (var i = 0; i < arr.length; i++) {
    if (!obj[arr[i].gameId]) {
      result.push(arr[i]);
      obj[arr[i].gameId] = true;
    }
  }
  return result;
}

const mutations = {
  setOpenAppLogin(state, openAppLoginStatus) {
    state.openAppLoginStatus = openAppLoginStatus;
  },

  setCheckUserGameEvaluationStateColse(state, list) {
    state.evaluationState.popup = false;
  },
  setCheckUserGameEvaluationState(state, list) {
    state.evaluationState = list;
  },

  setActionList(state, actionlist) {
    state.actionlist = actionlist;
  },
  setGameallIMG(state, GameList) {
    state.GameList = GameList;
  },
  setGameList(state, GameList) {
    // console.log('7777777777++++++++', rank)

    var box = [];
    var tacitlyLang = localStorage.getItem("tacitlyLang");
    var lang = localStorage.getItem("lang");
    var data = JSON.parse(GameList);
    var game = JSON.parse(localStorage.getItem("BIPGameList"));

    for (var i = 0; i < data.length; i++) {
      var tacitlytitle = "";
      data[i].title = JSON.parse(data[i].title);
      for (let j = 0; j < data[i].title.length; j++) {
        var datatitlelang = data[i].title[j].lang;
        if (
          datatitlelang &&
          lang &&
          datatitlelang.toLowerCase() == lang.toLowerCase()
        ) {
          data[i].title = data[i].title[j].values;
          break;
        } else if (
          datatitlelang &&
          tacitlyLang &&
          datatitlelang.toLowerCase() == tacitlyLang.toLowerCase()
        ) {
          tacitlytitle = data[i].title[j].values;
        }
      }
      if (typeof data[i].title == "object") {
        data[i].title = tacitlytitle;
      }
      for (var s = 0; s < data[i].gameIdList.length; s++) {
        for (var a = 0; a < game.length; a++) {
          if (data[i].gameIdList[s] == game[a].gameId) {
            data[i].gameIdList[s] = game[a];
          }
          if (
            typeof data[i].gameIdList[s].backUrl != "object" &&
            data[i].gameIdList[s].backUrl
          ) {
            data[i].gameIdList[s].backUrl = JSON.parse(
              data[i].gameIdList[s].backUrl
            );
          }
        }

        if (
          data[i] &&
          data[i].gameIdList[s] &&
          data[i].gameIdList[s].name &&
          data[i].gameIdList[s].name.indexOf("[") != -1
        ) {
          data[i].gameIdList[s].name = JSON.parse(data[i].gameIdList[s].name);
        }
        if (
          data[i] &&
          data[i].gameIdList[s] &&
          data[i].gameIdList[s].remark &&
          data[i].gameIdList[s].remark.indexOf("[") != -1
        ) {
          data[i].gameIdList[s].remark = JSON.parse(
            data[i].gameIdList[s].remark
          );
        }
        var tacitlyRemark = "";
        var tacitlyName = "";
        if (data[i] && data[i].gameIdList[s] && data[i].gameIdList[s].remark) {
          for (var d = 0; d < data[i].gameIdList[s].remark.length; d++) {
            if (
              lang &&
              data[i].gameIdList[s].remark[d].lang == lang.toUpperCase()
            ) {
              data[i].gameIdList[s].remark =
                data[i].gameIdList[s].remark[d].values;
            } else if (
              tacitlyLang &&
              data[i].gameIdList[s].remark[d].lang == tacitlyLang.toUpperCase()
            ) {
              tacitlytitle = data[i].gameIdList[s].remark[d].values;
            }
          }
        }
        if (data[i] && data[i].gameIdList[s] && data[i].gameIdList[s].name) {
          for (var d = 0; d < data[i].gameIdList[s].name.length; d++) {
            if (
              lang &&
              data[i].gameIdList[s].name[d].lang == lang.toUpperCase()
            ) {
              data[i].gameIdList[s].name = data[i].gameIdList[s].name[d].values;
            } else if (
              tacitlyLang &&
              data[i].gameIdList[s].name[d].lang == tacitlyLang.toUpperCase()
            ) {
              tacitlytitle = data[i].gameIdList[s].name[d].values;
            }
          }
        }
        if (typeof data[i].gameIdList[s].name == "object") {
          data[i].gameIdList[s].name = tacitlytitle;
        }
      }
      var gameList = data[i].gameIdList;
      let gameListAll = [];
      gameList.forEach(item => {
        if (typeof item === "object") {
          gameListAll.push(item);
        }
      });
      box.push({
        gameList: gameListAll,
        title: data[i].title
      });
    }
    if (box.length > 4 && box[2]) {
      box[2].gameList = shuffle(box[2].gameList);
      box[2].gameList = box[2].gameList.slice(0, 8);
    }

    if (box.length > 4 && box[3]) {
      box[3].gameList = shuffle(box[3].gameList);
      box[3].gameList = box[3].gameList.slice(0, 8);
    }
    var rankData = [];
    if (
      box[4] &&
      box[4].gameList &&
      localStorage.getItem("appId") != "124cad5d6fe64b55862adbbffbd9e1af" &&
      localStorage.getItem("appId") != "47b1181148da4063b5ef17759dcaee25"
    ) {
      for (let i = 0; i < box[4].gameList.length; i++) {
        if (box[4].gameList[i].gameId >= 77) {
          rankData.push(box[4].gameList[i]);
        }
      }
      box[4].gameList = rankData;
    }

    // for (var i = 0; i < game.length; i++) {
    //  console.log(game[i].gameId)
    //         if(game[i].gameId == 18){
    //             state.GameFlow = game[i]
    //           localStorage.setItem("GameFlow", JSON.stringify(game[i]));
    //          break
    //         }
    // }
    state.GameList = box;
    //         	  for (var i = 0; i < data.length; i++) {
    //         		  for (var j = 0; j < data[i].gameList.length; j++) {
    //         				 console.log(data[i].gameList[j].gameId)
    //         			  if(data[i].gameList[j].gameId == 18){
    //         			      state.GameFlow = data[i].gameList[j]
    //         				  localStorage.setItem("GameFlow", JSON.stringify(data[i].gameList[j]));
    //         				 return
    //         			  }
    //         		  }
    //
    //         	  }
  },
  // setRecentPlayList(state, { recentPlay, userId }) {
  //   let msisdn = localStorage.getItem("bipids");
  //   var rplist =
  //     JSON.parse(localStorage.getItem("recent_play" + msisdn) || "[]") || [];
  //   for (let i = 0; i < rplist.length; i++) {
  //     if (rplist[i].gameId == recentPlay.gameId) {
  //       rplist.splice(i, 1);
  //       break;
  //     }
  //   }
  //   rplist.unshift(recentPlay);
  //   console.log("rplist", rplist);
  //   state.recentPlayList = rplist;
  //   localStorage.setItem("recent_play" + msisdn, JSON.stringify(rplist));
  //   // const i = rplist.findIndex(o => o.GameId == recentPlay.GameId);
  //   // if (i == -1) {
  //   //   rplist.unshift(recentPlay);
  //   //   state.recentPlayList = rplist;
  //   //   localStorage.setItem("recent_play" + userId, JSON.stringify(rplist));
  //   // }
  // },
  setRecentPlayList(state, { recentPlay, userId }) {
    var rplist = [...state.recentPlayList];
    let msisdn = localStorage.getItem("msisdn");
    if (rplist.length == 0) {
      rplist =
        JSON.parse(localStorage.getItem("recent_play" + msisdn) || "[]") || [];
    }
    for (let i = 0; i < rplist.length; i++) {
      if (rplist[i].gameId == recentPlay.gameId) {
        rplist.splice(i, 1);
        break;
      }
    }
    rplist.unshift(recentPlay);
    console.log("rplist", rplist);
    state.recentPlayList = rplist;
    localStorage.setItem("recent_play" + msisdn, JSON.stringify(rplist));
  },
  // PlayList 判断游戏列表是否有这个游戏如果没有有就删除
  RemovePlayList(state, recentPlay) {
    var data = recentPlay;
    var recent_play = JSON.parse(
      localStorage.getItem("recent_play" + localStorage.getItem("bipids"))
    );
    if (recent_play) {
      let newArray = [];
      recent_play.forEach(item => {
        data.forEach(ele => {
          if (item.GameId) {
            item.gameId = item.GameId;
          }
          if (ele.gameId == item.gameId) {
            newArray.push(item);
          }
        });
      });

      localStorage.setItem(
        "recent_play" + localStorage.getItem("bipids"),
        JSON.stringify(newArray)
      );
    }
  }
};

// const getters = {
//   isPlayList: state => {
//     var rplist = [...state.recentPlayList];
//     if (rplist.length == 0) {
//       rplist =
//         JSON.parse(
//           localStorage.getItem(
//             "recent_play" + localStorage.getItem("bipids")
//           ) || "[]"
//         ) || [];
//     }
//     if (rplist.length > 0) {
//       return true;
//     } else {
//       return false;
//     }
//   },
const getters = {
  isPlayList: state => {
    var bipidsrplist =
      JSON.parse(
        localStorage.getItem("recent_play" + localStorage.getItem("bipids")) ||
        "[]"
      ) || [];
    var msisdnrplist =
      JSON.parse(
        localStorage.getItem("recent_play" + localStorage.getItem("msisdn")) ||
        "[]"
      ) || [];
    console.log(msisdnrplist, "lail a ++++++++a", bipidsrplist);
    if (bipidsrplist.length > 0) {
      console.log("bipidsrplist.length1111");
      return bipidsrplist;
    } else if (msisdnrplist.length > 0) {
      console.log("msisdnrplist.length2222");
      return msisdnrplist;
    } else {
      console.log("444444");
      return [];
    }
  },

  // getIosRecentPlayList: state => userId => {
  //   var rplist = [...state.recentPlayList];
  //   if (rplist.length == 0) {
  //     rplist =
  //       JSON.parse(
  //         localStorage.getItem(
  //           "recent_play" + localStorage.getItem("bipids")
  //         ) || "[]"
  //       ) || [];
  //   }
  //   if (rplist.length > 0) {
  //     for (let i = 0; i < rplist.length; i++) {
  //       if (rplist[i].ImageSrc) {
  //         rplist.splice(i, 1);
  //       } else if (
  //         rplist[i].playUrl &&
  //         rplist[i].playUrl.indexOf("/tgadpGame") == -1
  //       ) {
  //         rplist.splice(i, 1);
  //       }
  //     }
  //   }
  //   var gamelist =
  //     JSON.parse(
  //       localStorage.getItem("recent_play" + localStorage.getItem("bipids")) ||
  //         "[]"
  //     ) || [];
  //   if (gamelist.length > 0) {
  //     rplist = unique([...gamelist, ...rplist]);
  //   }
  //   if (
  //     JSON.parse(
  //       localStorage.getItem("recent_play" + localStorage.getItem("bipids"))
  //     )
  //   ) {
  //     localStorage.removeItem("recent_play" + localStorage.getItem("bipids"));
  //   }
  //   // 现在最近玩的游戏只有5个
  //   if (rplist.length > 5) {
  //     rplist.splice(5, rplist.length - 5);
  //   }

  //   localStorage.setItem(
  //     "recent_play" + localStorage.getItem("bipids"),
  //     JSON.stringify(rplist)
  //   );

  //   return rplist;
  // },
  getIosRecentPlayList: state => userId => {
    console.log("lai zheli l a ");
    var rplist = [...state.recentPlayList];
    if (rplist.length == 0) {
      rplist =
        JSON.parse(
          localStorage.getItem(
            "recent_play" + localStorage.getItem("bipids")
          ) || "[]"
        ) || [];
    }
    if (rplist.length > 0) {
      for (let i = 0; i < rplist.length; i++) {
        if (rplist[i].ImageSrc) {
          rplist.splice(i, 1);
        } else if (
          rplist[i].playUrl &&
          rplist[i].playUrl.indexOf("/tgadpGame") == -1
        ) {
          rplist.splice(i, 1);
        }
      }
    }
    var gamelist =
      JSON.parse(
        localStorage.getItem("recent_play" + localStorage.getItem("msisdn")) ||
        "[]"
      ) || [];
    if (gamelist.length > 0) {
      rplist = unique([...gamelist, ...rplist]);
    }
    if (
      JSON.parse(
        localStorage.getItem("recent_play" + localStorage.getItem("bipids"))
      )
    ) {
      localStorage.removeItem("recent_play" + localStorage.getItem("bipids"));
    }
    // 现在最近玩的游戏只有5个
    for (var i = 0; i < rplist.length; i++) {
      if (rplist[i].gameId == 153) {
        rplist.splice(i, 1);
      }
    }

    if (rplist.length > 5) {
      rplist.splice(5, rplist.length - 5);
    }
    var game = JSON.parse(localStorage.getItem("BIPGameList"));
    var gameIds = game.map(item => item.gameId);

    for (var i = 0; i < rplist.length; i++) {
      if (gameIds.indexOf(rplist[i].gameId) === -1) {
        rplist.splice(i, 1);
      }
    }
    localStorage.setItem(
      "recent_play" + localStorage.getItem("msisdn"),
      JSON.stringify(rplist)
    );
    console.log("rplist", rplist);

    return rplist;
  },
  getRecentPlayList: state => userId => {
    var rplist = [...state.recentPlayList];

    if (rplist.length == 0) {
      rplist =
        JSON.parse(
          localStorage.getItem(
            "recent_play" + localStorage.getItem("bipids")
          ) || "[]"
        ) || [];
    }

    if (rplist.length > 0) {
      for (let i = 0; i < rplist.length; i++) {
        if (rplist[i].ImageSrc) {
          rplist.splice(i, 1);
        } else if (
          rplist[i].playUrl &&
          rplist[i].playUrl.indexOf("/tgadpGame") == -1
        ) {
          rplist.splice(i, 1);
        }
      }
    }
    var gamelist =
      JSON.parse(
        localStorage.getItem("recent_play" + localStorage.getItem("msisdn")) ||
        "[]"
      ) || [];
    if (gamelist.length > 0) {
      rplist = unique([...gamelist, ...rplist]);
    }
    if (
      JSON.parse(
        localStorage.getItem("recent_play" + localStorage.getItem("bipids"))
      )
    ) {
      localStorage.removeItem("recent_play" + localStorage.getItem("bipids"));
    }
    var game = JSON.parse(localStorage.getItem("BIPGameList"));
    var gameIds = game.map(item => item.gameId);

    for (var i = 0; i < rplist.length; i++) {
      if (gameIds.indexOf(rplist[i].gameId) === -1) {
        rplist.splice(i, 1);
      }
    }
    localStorage.setItem(
      "recent_play" + localStorage.getItem("msisdn"),
      JSON.stringify(rplist)
    );
    return rplist;
  }
};
//   getRecentPlayList: state => userId => {
//     var rplist = [...state.recentPlayList];
//     if (rplist.length == 0) {
//       rplist =
//         JSON.parse(
//           localStorage.getItem(
//             "recent_play" + localStorage.getItem("bipids")
//           ) || "[]"
//         ) || [];
//     }

//     if (rplist.length > 0) {
//       for (let i = 0; i < rplist.length; i++) {
//         if (rplist[i].ImageSrc) {
//           rplist.splice(i, 1);
//         } else if (
//           rplist[i].playUrl &&
//           rplist[i].playUrl.indexOf("/tgadpGame") == -1
//         ) {
//           rplist.splice(i, 1);
//         }
//       }
//     }
//     var gamelist =
//       JSON.parse(
//         localStorage.getItem("recent_play" + localStorage.getItem("bipids")) ||
//           "[]"
//       ) || [];
//     if (gamelist.length > 0) {
//       rplist = unique([...gamelist, ...rplist]);
//     }
//     if (
//       JSON.parse(
//         localStorage.getItem("recent_play" + localStorage.getItem("bipids"))
//       )
//     ) {
//       localStorage.removeItem("recent_play" + localStorage.getItem("bipids"));
//     }
//     localStorage.setItem(
//       "recent_play" + localStorage.getItem("bipids"),
//       JSON.stringify(rplist)
//     );
//     return rplist;
//   }
// };
const actions = {
  // async jsonPost({
  //   state,
  //   commit,
  //   dispatch
  // }, {
  //   $axios,
  //   ...postData
  // }) {
  //   console.log('开始发送数据', new Date().getTime())
  //   const res = await $axios.get(` http://161.189.89.42:8081/h5tga/aa.json`, {
  //     ...postData,
  //   });
  //   console.log('开始接收数据', new Date().getTime())
  //   console.log('resresres', res)

  // },

  // 是否打开APP的登录弹出框
  async openAppLogin({ state, commit, dispatch }, { $axios, ...postData }) {
    commit("setOpenAppLogin", postData.status);
  },

  // 查询评分弹窗状态接口
  async checkUserGameEvaluationState(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");

    const res = await require.myget(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpGame/checkUserGameEvaluationState`,
      {
        ...postData
      }
    );

    console.log("checkUserGameEvaluationState", res);
    if (res.data.stateCode == 1) {
      const obj = {
        ...res.data.resultInfo,
        type: postData.type
      };
      commit("setCheckUserGameEvaluationState", obj);
    }
    return res.data;
  },

  //关闭评分页面
  async setCloseEvaluation({ state, commit, dispatch }) {
    commit("setCheckUserGameEvaluationStateColse", false);
  },

  // 提交评分数据
  async commitUserGameEvaluation(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpGame/commitUserGameEvaluation`,
      {
        ...postData
      }
    );
    console.log("commitUserGameEvaluation", res);
    return res.data;
  },

  // 获取分享地址
  async GetShareUrl(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");

    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/bip/GetShareUrl`,
      {
        ...postData
      }
    );

    console.log("GetShareUrl", res);
    return res.data.resultInfo.url;
  },
  // 获取游戏活动的列表
  async ActionList(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");

    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/bip/ActionList`,
      {
        ...postData
      }
    );

    commit("setActionList", res.data.resultInfo.data[0]);

    console.log("ActionList", res);
    return res.data.resultInfo.data[0];
  },

  // 获取游戏的列表
  async ActionGameList(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");
    var lang = localStorage.getItem("lang");
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpGame/ThirdGameList`,
      {
        ...postData,
        appId: configs.bipAppId()
      }
    );

    console.log("ThirdGameList", res);
    //     try {
    //       $axios.post("/sb/tgadpGame/ThirdGameList", {
    //         ...postData,
    //         appId: configs.bipAppId()
    //       });
    //     } catch (e) {}
    //
    //
    //     try {
    //       $axios.post("/sb/tgadpGame/ThirdGameIdList", {
    //         ...postData,
    //         appId:configs.bipAppId()
    //       });
    //     } catch (e) {}

    if (res.data.stateCode == 1) {
      let gameList = res.data.resultInfo.gameList;
      let list = res.data.resultInfo.data;

      // if (!configs.guolv()) {
      //   for (let i = 0; i < list.length; i++) {
      //     for (let j = 0; j < list[i].gameIdList.length; j++) {
      //       if (list[i].gameIdList[j] == 77) {
      //         list[i].gameIdList.splice(j, 1)
      //       }
      //     }
      //   }

      //   for (let i = 0; i < gameList.length; i++) {
      //     if (gameList[i].gameId == 77) {
      //       gameList.splice(i, 1)
      //     }

      //   }
      // }

      localStorage.setItem("BIPVersion", res.data.resultInfo.version);
      localStorage.setItem("BIPGameList", JSON.stringify(gameList));

      commit("setGameList", JSON.stringify(list));

      commit("RemovePlayList", gameList);

      //       var en = [`MOST POPULAR`, `EDITOR'S CHOICE`, `DAILY DISCOVERY`, `GUESS YOU LIKE`, `OVERALL RANKING`]
      //       var tr = [`EN POPÜLER`, `EDİTÖRÜN SEÇİMİ`, `GÜNLÜK KEŞİF`, `BEĞENEBİLİRSİN`, `GENEL SIRALAMA`]
      //       var list = res.data.resultInfo.data
      //       var Colortable = {}
      //       var gametable = {}
      //       for (let s of res.data.resultInfo.data[2].gameList) {
      //         gametable[s.GameId] = JSON.parse(JSON.stringify(s))
      //       }
      //       var rankgame = []
      //       for (let r of rank) {
      //         let gameid = r.GameId
      //         Colortable[gameid] = JSON.parse(JSON.stringify(r.Color))
      //         if (gameid && gametable[gameid] && gametable[gameid].GameId) {
      //           gametable[gameid].TotalPlayer = r.TotalPlayer
      //           gametable[gameid].BackUrl = r.Color
      //           rankgame.push(gametable[gameid])
      //         }
      //       }
      //
      //       for (let l of list) {
      //         for (let g of l.gameList) {
      //           if (gametable[g.GameId] && gametable[g.GameId].GameId) {
      //             let r = gametable[g.GameId]
      //             g.TotalPlayer = r.TotalPlayer
      //           }
      //           if (Colortable && Colortable[g.GameId]) {
      //             g.BackUrl = Colortable[g.GameId]
      //           }
      //         }
      //       }
      //       var games = {
      //         gameList: rankgame,
      //         title: "123",
      //       }
      //
      //       list[2].gameList = shuffle(list[2].gameList)
      //       list[3].gameList = shuffle(list[3].gameList)
      //       list[3].gameList = list[3].gameList.slice(0, 8)
      //       list[2].gameList = list[2].gameList.slice(0, 8)
      //       list.push(games)
      //       for (var i = 0; i < list.length; i++) {
      //         if (lang == 'tr') {
      //           list[i].title = tr[i]
      //         } else {
      //           list[i].title = en[i]
      //         }
      //       }
      //       commit("setGameList", JSON.stringify(list));
      //       console.log('list',list)
      // var list = res.data.resultInfo.data
      // localStorage.setItem('BIPVersion',res.data.resultInfo.version)
      // localStorage.setItem('BIPGameList',JSON.stringify(res.data.resultInfo.gameList))
      // commit("setGameList",list);

      // commit('RemovePlayList', rankgame)
    }
    return true;
  },

  // 获取游戏ID列表
  async ActionGameIdList(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");

    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpGame/ThirdGameIdList`,
      {
        ...postData,
        appId: configs.bipAppId()
      }
    );

    console.log("ThirdGameIdList", res);
    var list = res.data.resultInfo.data;
    // localStorage.setItem('BIPGameList',res.data.resultInfo.gameList)
    if (res.data.resultInfo.version != localStorage.getItem("BIPVersion")) {
      localStorage.setItem("BIPVersion", res.data.resultInfo.version);
      return false;
    } else {
      // if (!configs.guolv()) {
      //   for (let i = 0; i < list.length; i++) {
      //     for (let j = 0; j < list[i].gameIdList.length; j++) {
      //       if (list[i].gameIdList[j] == 77) {
      //         list[i].gameIdList.splice(j, 1)
      //       }
      //     }
      //   }
      // }

      commit("setGameList", JSON.stringify(list));
      return true;
    }
  },

  // 保存游戏
  changeRecentPlayList({ commit, dispatch }, { $axios, recentPlay, userId }) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");
    if (recentPlay) {
      commit("setRecentPlayList", {
        recentPlay,
        userId
      });
    }
  },
  // 搜索游戏
  async searchGame(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");

    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpGame/SearchGame`,
      {
        ...postData,
        appId: configs.bipAppId()
        // "token":localStorage.getItem("Bearer") || "none"
      }
    );

    console.log("SearchGame", res);
    if (res.data.stateCode == 1) {
      var list = res.data.resultInfo;
      // if (!configs.guolv()) {
      //   for (let i = 0; i < list.list.length; i++) {
      //     if (list.list[i].gameId == 77) {
      //       list.list.splice(i, 1)
      //     }
      //   }
      // }

      return list || [];
    }
    return false;
  },
  // 获取游戏详情页面
  async ActionInfo(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");

    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/bip/ActionInfo`,
      {
        ...postData
      }
    );
    console.log("ActionInfo", res);
    // res.data.resultInfo.data.startTime = NewData(res.data.resultInfo.data)
    // var list = res.data.resultInfo;
    return res.data.resultInfo.data;
  },

  // 获取用户任务列表
  async ActionUserTasks(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/bip/ActionUserTasks`,
      {
        ...postData
      }
    );
    console.log("ActionUserTasks", res);
    // res.data.resultInfo.data.startTime = NewData(res.data.resultInfo.data)
    // var list = res.data.resultInfo;
    return res.data.resultInfo.data;
  },

  // 获取宝箱时间
  async ActionUserBox({ state, commit, dispatch }, { $axios, ...postData }) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/bip/ActionUserBox`,
      {
        ...postData
      }
    );
    console.log("ActionUserBox", res);
    return res.data.resultInfo;
  },
  // 获取排行列表
  async ActionUserRank(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/bip/ActionUserRank`,
      {
        ...postData
      }
    );
    console.log("ActionUserRank", res);
    return res.data.resultInfo.data;
  },

  /*--------*/
  // 这个给是获取活动状态
  async CheckActionState(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/bip/CheckActionState`,
      {
        ...postData
      }
    );
    console.log("CheckActionState ", res);
    return res.data;
  },

  async GetActionFlow({ state, commit, dispatch }, { $axios, ...postData }) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/bip/GetActionFlow`,
      {
        ...postData
      }
    );
    console.log("GetActionFlow ", res);
    return res.data;
  },

  //获取游戏结果页面
  async gameResult(
    { commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");
    //获取游戏结果页面
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/Game/GameResult`,
      {
        ...postData
      }
    );

    console.log("GameResult", res);
    return res.data.Data || {};
  },

  async GetCodeResult({ commit, dispatch }, { $axios, ...postData }) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");
    //获取游戏结果页面
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/Open/GetCodeResult`,
      {
        ...postData
      }
    );

    console.log("GetCodeResult", res);
    return res.data;
  },

  async getGameRankList(
    { commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");

    //获取游戏用户排行
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/Game/GetGameRankList`,
      {
        ...postData
      }
    );
    console.log("GetGameRankList", res);
    return res.data.Data;
  },

  async getUserFriendGameRankList(
    { commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    $axios.setToken(localStorage.getItem("Bearer") || "", "Bearer");

    //获取游戏朋友圈排行
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tga/Game/GetUserFriendGameRankList`,
      {
        ...postData
      }
    );
    console.log("GetUserFriendGameRankList", res);
    return res.data.Data;
  },

  // async gamePlay({ commit, dispatch }, { $axios, $router, url ,isreplace}) {
  async gamePlay(
    { commit, dispatch, rootState },
    { $axios, $router, $root, ...postData }
  ) {
    var token = localStorage.getItem("Bearer") || "none";
    // 判断url是否含有https://bipgaming.tvoip.turkcell.com.tr/sb/ 然后删除
    var url = postData.url.replace(
      "https://bipgaming.tvoip.turkcell.com.tr/sb/",
      ""
    );
    const playUrl = `${tgaPlatformSDK.data.apiBaseHost}/${url.replace(
      /^\/sb/,
      ""
    )}`;
    const res = await require.mypost($axios, playUrl, {
      token: token
    });

    // return;
    // if (postData.url && postData.url.indexOf("/tga/Game/GameStart") > 0) {
    //   let copy_url = postData.url.replace("/tga/Game/GameStart", "/tgadpGame/GameStart")
    //   $axios.post(copy_url + '&token=' + token, {});
    // }

    if (res.data.stateCode == 1) {
      // let resdata = JSON.parse(JSON.stringify(rootState.user.userInfo));
      // console.log("运行记录组件接到的数据", resdata);
      // console.log("  !resdata.txnId", !resdata.txnId);
      // if (
      //   res.data.resultInfo.gameInfo &&
      //   res.data.resultInfo.gameInfo.tags &&
      //   !resdata.txnId
      // ) {
      //   commit("setOpenAppLogin", true);
      //   return false;
      // }

      let gamedata = res.data.Data || res.data.resultInfo.data;
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      var url = res.data.resultInfo.data.url;
      const txnId = localStorage.getItem("txn_id");
      let istxnId = txnId ? "&txn-id=" + txnId : "";
      let adTest = "";
      let adOff = 0;
      // let cdnUrl = "https://tga.baek.top/tga-h5/game-play.html";
      // 判断deployType是否为2
      let deployType = res.data.resultInfo.gameInfo.deployType || 0;
      if (deployType == 2) {
        url =
          res.data.resultInfo.gameInfo.playurl +
          "?&app-id=" +
          configs.bipAppId() +
          "&lang=" +
          localStorage.getItem("lang") +
          "&game-id=" +
          gamedata.gameId;
      } else {
        let cdnUrl = `${window.location.origin}/tga-h5/game-play.html`;
        if (tgaPlatformSDK.data.env === "bip-test") {
          adTest = 1;
          // adOff = 1;
        } else if (tgaPlatformSDK.data.env === "bip") {
          adTest = 0;
          // adOff = 1;
        } else if (tgaPlatformSDK.data.env === "production") {
          adTest = 0;
        } else if (tgaPlatformSDK.data.env === "test") {
          adTest = 0;
        } else {
          adTest = 1;
        }
        // if ($root.adOff) adOff = 1;
        // 首先判断是否是安卓
        if (isAndroid) {
          // 判断安卓版本号是不是大于3.74
          if (gamedata.gameId >= 77) {
            url =
              cdnUrl +
              "?ad-test=" +
              adTest +
              "&ad-off=" +
              adOff +
              "&env=" +
              tgaPlatformSDK.data.env +
              "&app-id=" +
              configs.bipAppId() +
              istxnId +
              "&game-id=" +
              gamedata.gameId +
              "&lang=" +
              localStorage.getItem("lang") +
              "&token=" +
              localStorage.getItem("Bearer") +
              "&refresh-token=" +
              localStorage.getItem("refreshToken") +
              "&theme=" +
              localStorage.getItem("theme");
          } else {
            url = url
              .replace("https://joysungame.com", "https://20games.com")
              .replace("channel=j4f", "channel=j4f1");
          }
        } else {
          if (gamedata.gameId >= 77) {
            url =
              cdnUrl +
              "?ad-test=" +
              adTest +
              "&ad-off=" +
              adOff +
              "&env=" +
              tgaPlatformSDK.data.env +
              "&app-id=" +
              configs.bipAppId() +
              istxnId +
              "&game-id=" +
              gamedata.gameId +
              "&lang=" +
              localStorage.getItem("lang") +
              "&token=" +
              localStorage.getItem("Bearer") +
              "&refresh-token=" +
              localStorage.getItem("refreshToken") +
              "&theme=" +
              localStorage.getItem("theme");
          }
        }
      }
      console.log("url", url);

      if (window.TgaBridge) {
        let goPage = {
          url: url,
          navigationBar: {
            display: false,
            backgroundColor: "#ffffff"
          },
          statusBarDisplay: {
            display: true
          }
        };
        const res = await TgaBridge.goPage(JSON.stringify(goPage));
        if (res) {
          dispatch("checkUserGameEvaluationState", {
            $axios: $axios,
            type: 0,
            gameId: gamedata.gameId
          });
          return false;
        }
      } else if (window.Bridge) {
        let color = "";
        switch (localStorage.getItem("theme")) {
          case "dark-blue":
            color = "#12172a";
            break;
          case "dark":
            color = "#0f0d14";
            break;
          case "candlelight":
            color = "#ffdb0d";
            break;
          case "lavender":
            color = "#9876d0";
            break;
          case "orange":
            color = "#fa9c2a";
            break;
          case "night-blue":
            color = "#213042";
            break;
          default:
            color = "#03a9f5";
            break;
        }
        let goPage = {
          url: url,
          isShowNavigation: false,
          isShowStatusBar: true,
          statusBarColor: color
        };
        window.Bridge.system.goPage(goPage);
      } else {
        window.location.href = url;
        return false;
      }
    }
    //  	var spurl = res.data.Data.url.split("++++")
    //  	console.log('spurlspurl',spurl)
    //
    //  	if(spurl.length >= 2){
    //  		console.log('spurlspurl2')
    //  		console.log('spurlspurl2',localStorage.getItem('TgaAndroid'))
    //  		if(localStorage.getItem('TgaAndroid') == 'none'){
    //  			window.location.href= spurl[1]
    //
    //  		}else{
    //  			$router.push({
    //  			  path: '/loading',
    //  			  query:{
    //  			    // url:res.data.Data.url,
    //  			    url:spurl[0],
    //  			    icon:postData.ImageSrc
    //  			    },
    //  			});
    //  		}
    //  	}else{
    //  		window.location.href= spurl[0]
    //
    //  	}
    // console.time('href');
    // window.location.href= res.data.Data.url
    // console.timeEnd('href');
  },

  // 用户签到
  async userSign({ commit, dispatch }, { $axios, ...postData }) {
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpUser/UserSign`,
      {
        ...postData,
        appId: configs.bipAppId()
      }
    );
    console.log("UserSign", res);
    return res.data;
  },
  // 用户签到状态
  async userSignState({ commit, dispatch }, { $axios, ...postData }) {
    //用户签到
    const res = await require.myget(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpUser/UserSignState`,
      {
        ...postData
      }
    );
    console.log("UserSignState", res);
    return res.data;
  },

  // 签到天数及奖品列表
  async userSignRewards({ commit, dispatch }, { $axios, ...postData }) {
    const res = await require.myget(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpUser/UserSignRewards`,
      {
        // ...postData,
        // appId:configs.bipAppId()
      }
    );
    console.log("UserSignRewards", res);
    return res.data;
  },

  // 获取任务列表
  async tasks({ commit, dispatch }, { $axios, ...postData }) {
    const res = await require.myget(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpUser/Tasks`,
      {
        // ...postData,
        // appId:configs.bipAppId()
      }
    );
    console.log("Tasks", res);
    return res.data;
  },

  // 领取任务/成就奖励
  async getReward({ commit, dispatch }, { $axios, ...postData }) {
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpUser/GetReward`,
      {
        ...postData
        // appId:configs.bipAppId()
      }
    );
    console.log("GetReward", res);
    return res.data;
  },

  // 查询货币流水
  async CoinList({ commit, dispatch }, { $axios, ...postData }) {
    const res = await require.mypost(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpPayment/CoinList`,
      {
        ...postData,
        appId: configs.bipAppId()
      }
    );
    console.log("CoinList", res);
    return res.data;
  },

  // 获取成就列表
  async achievements({ commit, dispatch }, { $axios, ...postData }) {
    const res = await require.myget(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpUser/Achievements`,
      {
        // ...postData,
      }
    );
    console.log("Achievements", res);
    return res.data;
  },

  // 获取成就详情
  async userAchievements({ commit, dispatch }, { $axios, ...postData }) {
    const res = await require.myget(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpUser/UserAchievements`,
      {
        // ...postData,
      }
    );
    console.log("UserAchievements", res);
    return res.data;
  },

  //签到
  async userActiveReport({ commit, dispatch }, { $axios, ...postData }) {
    const res = await require.myget(
      $axios,
      `${tgaPlatformSDK.data.apiBaseHost}/tgadpUser/userActiveReport`,
      {
        // ...postData,
      }
    );
    console.log("userActiveReport", res);
    return res.data;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/vuex/modules/game.js